const e = "";
export {
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/components/lianshenhuabian/lianshenhuabian.vue3.js
// module id = 1264
// module chunks = 67